import React from 'react';
const baseUrl = (module, path) => "".concat(process.env.REACT_APP_BASE_URL, "/").concat(module).concat(process.env.REACT_APP_URL_ENV, "/").concat(path);
const link = function (url, label) {
  let blank = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return blank ? /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: url,
    rel: "noreferrer"
  }, label) : /*#__PURE__*/React.createElement("a", {
    href: url
  }, label);
};
const Links = {};
Links.baseUrl = (module, path) => baseUrl(module, path);
Links.link = function (url, label) {
  let blank = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return link(url, label, blank);
};
Links.getLink = function (module, path, label) {
  let blank = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return link(baseUrl(module, path), label, blank);
};
export default Links;